"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonBaseStyles = void 0;

var _styledComponents = require("styled-components");

var _Box = require("../Box");

var _baseStyle = require("../shared/baseStyle");

var _getComponentStyle = require("../styleHelpers/getComponentStyle");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var buttonBaseStyles = (0, _styledComponents.css)(["", " display:inline-flex;flex-direction:row;align-items:center;text-decoration:none;padding:", ";border:", "px solid transparent;background:transparent;border-radius:", ";transition:", ";outline:none;&:not(:disabled){cursor:pointer;}&:disabled{opacity:", ";cursor:normal;}", ""], _baseStyle.baseStyle, (0, _getComponentStyle.getComponentStyle)('button.sizes.{size}.padding'), (0, _getComponentStyle.getComponentStyle)('button.base.borderSize'), (0, _getComponentStyle.getComponentStyle)('button.base.borderRadius'), (0, _getComponentStyle.getComponentStyle)('button.base.transitions', _getComponentStyle.transitionTransformer), (0, _getComponentStyle.getComponentStyle)('button.base.disabled.opacity'), function (_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return (0, _Box.layoutInterpolationFn)(props);
});
exports.buttonBaseStyles = buttonBaseStyles;